import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';
import {SongProps} from '../../components/song/song.types';
import {SETLIST} from '../../pages/setlist/setlist.mock';

export interface CounterState {
	title: string;
	setlist: SongProps[];
	order: number[];
}

const initialState: CounterState = {
	title: 'Add & Reorder Setlist',
	setlist: SETLIST,
	order: [],
};

export const setlistReducer = createSlice({
	name: 'setlist',
	initialState,
	reducers: {
		setSlideUpTitle: (state, action: PayloadAction<string>) => {
			state.title = action.payload;
		},
		setAsPlayed: (state, action: PayloadAction<number | undefined>) => {
			const song = state.setlist.find((item) => item.index === action.payload);
			if (song) {
				Object.assign(song, {played: true});
			}
		},
		setAsNotPlayed: (state, action: PayloadAction<number | undefined>) => {
			const song = state.setlist.find((item) => item.index === action.payload);
			if (song) {
				Object.assign(song, {played: false});
			}
		},
		setOrder: (state, action: PayloadAction<number[]>) => {
			action.payload.forEach((item, i) => {
				state.setlist[item - 1].index = i + 1;
			});
		},
	},
});

export const {setSlideUpTitle, setAsPlayed, setAsNotPlayed, setOrder} = setlistReducer.actions;

export default setlistReducer.reducer;
